
const CLASSIFICATION_OPTIONS = {
    J: 'Journeyman',
    F: 'Foreman',
    S: 'Superintendent',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8'
}

export function createJobDayCards(jobDay) {

    let cards = []

    jobDay.crewMemberAssignments.forEach(assignment => {
        cards.push({
            ...assignment.crewMember,
            classification: CLASSIFICATION_OPTIONS[assignment.crewMember.classification]
        })
    })

    return cards
}


